import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import "./footer.css"; // Unique CSS file

const CustomFooter = () => {
  return (
    <footer className="custom-footer">
      <div className="custom-container">
        <div className="custom-footer-grid">
          
          {/* Home Column */}
          <div className="custom-column">
            <h3>Home</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
            </ul>
          </div>

          {/* Academics Column */}
          <div className="custom-column">
            <h3>Academics</h3>
            <ul>
              <li><Link to="/basicscienceuser">Basic Science</Link></li>
              <li><Link to="/civilengineeruser">Civil Engineering</Link></li>
              <li><Link to="/computerscienceuser">Computer Science</Link></li>
              <li><Link to="/physicaleducationuser">Physical Education</Link></li>
              <li><Link to="/electricalengineeruser">Electrical Engineering</Link></li>
              <li><Link to="/mechanicalengineeruser">Mechanical Engineering</Link></li>
              <li><Link to="/electronicsengineeruser">Electronics & Communication</Link></li>
            </ul>
          </div>

          {/* About Column */}
          <div className="custom-column">
            <h3>About</h3>
            <ul>
              <li><Link to="/administration">Administration</Link></li>
              <li><Link to="/managingtrustee">Managing Trustee</Link></li>
              <li><Link to="/mission">Vision and Mission</Link></li>
              <li><Link to="/chairman">Founder/Chairman</Link></li>
              <li><Link to="/principal">Principal's Message</Link></li>
              <li><Link to="/history">History of PACE Group</Link></li>
              <li><Link to="/leadership">Board of Trustees</Link></li>
            </ul>
          </div>

          {/* Admission Column */}
          <div className="custom-column">
            <h3>Admission</h3>
            <ul>
              <li><Link to="/admission/hostel">Hostels</Link></li>
              <li><Link to="/admission/library">Library</Link></li>
              <li><Link to="/SeminarHall">Seminar Hall</Link></li>
              <li><Link to="/canteen">Canteen/Mess</Link></li>
              <li><Link to="/admission/transport">Transportation</Link></li>
              <li><Link to="/admission/fitness">Sports and Fitness</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="custom-column">
            <h3>Contact</h3>
            <div className="custom-contact-details">
              <p>P.A. Polytechnic</p>
              <p>Nadupadav, Montepadav Post</p>
              <p>Kairangala, Mangalore - 574153</p>
              <p>Karnataka, INDIA</p>
              <p>Phone: 0824-2284701</p>
              
              <p>Mobile: +91 9964668925</p>
              <p>Email: <a href="mailto:principal@papt.edu.in">principal@papt.edu.in</a></p>

              {/* Instagram Link */}
              <div className="custom-instagram">
                <a
                  href="https://www.instagram.com/mohammed_shafeeq_ue"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="custom-instagram-link"
                >
                  <FaInstagram className="custom-insta-icon" />
                  <span>P.A_Polytecnic</span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Legal Section */}
      <div className="custom-legal1">
        <p>© 2025 P.A. Polytechnic, Mangalore</p>
        <p>Site by | <a href="https://mehwartechnology.com" target="_blank" rel="noopener noreferrer">Mehwar Technologies</a></p>
      </div>
    </footer>
  );
};

export default CustomFooter;
